import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { ResponseTransformer } from './request.types';

export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

export const httpClient = axios.create({
  baseURL: BASE_API_URL,
  withCredentials: true,
  timeout: 30000,
});

async function request<T>(
  config: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return httpClient
    .request<T>(config)
    .then((response) => {
      if (
        response instanceof AxiosError &&
        response?.response &&
        response?.response?.status >= 400
      ) {
        throw response;
      }
      return responseTransformer ? responseTransformer(response) : response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export function getRequest<T>(
  url: string,
  config?: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return request<T>({ method: 'GET', url, ...config }, responseTransformer);
}

export function putRequest<T>(
  url: string,
  config?: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return request<T>({ method: 'PUT', url, ...config }, responseTransformer);
}

export function postRequest<T>(
  url: string,
  config?: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return request<T>({ method: 'POST', url, ...config }, responseTransformer);
}

export function patchRequest<T>(
  url: string,
  config?: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return request<T>({ method: 'PATCH', url, ...config }, responseTransformer);
}

export function deleteRequest<T>(
  url: string,
  config?: AxiosRequestConfig,
  responseTransformer?: ResponseTransformer<T>
) {
  return request<T>({ method: 'DELETE', url, ...config }, responseTransformer);
}
